import type { UseI18nOptions } from '#i18n'

export const useGlobalI18n = (_: UseI18nOptions = {}) => {
  const { $i18n } = useNuxtApp()
  return $i18n
}
